// extracted by mini-css-extract-plugin
export var aboveInput = "_hk-0";
export var actionButton = "_hk-5";
export var actionButtonContainer = "_hk-1";
export var actionIcon = "_hk-6";
export var aiInfoContainer = "_hk-2";
export var attachmentWrapper = "_hk-7";
export var bold = "_hk-3";
export var checkIcon = "_hk-8";
export var clickingRecipientBar = "_hk-11";
export var commentThreadSwitch = "_hk-a";
export var draftImage = "_hk-b";
export var draftImageContainer = "_hk-c";
export var draftImages = "_hk-e";
export var editButton = "_hk-g";
export var editor = "_hk-f";
export var editorContainer = "_hk-y";
export var editorErrorTooltipWrapper = "_hk-9";
export var headerDivider = "_hk-h";
export var icon = "_hk-i";
export var info = "_hk-j";
export var internal = "_hk-n";
export var internalDivider = "_hk-k";
export var internalMessage = "_hk-l";
export var messageInputCard = "_hk-m";
export var messageInputForm = "_hk-o";
export var messageInputFormInternal = "_hk-p";
export var options = "_hk-q";
export var publicMessageCustomer = "_hk-s";
export var publicMessageMerchant = "_hk-r";
export var removeImageButton = "_hk-d";
export var replyButtons = "_hk-t";
export var showSignatureButton = "_hk-u";
export var spinner = "_hk-v";
export var verticalButtonDivider = "_hk-4";
export var visibilitySelector = "_hk-w";
export var warning = "_hk-x";
export var wrappingText = "_hk-z";
export var writingInternalNoteTopBorder = "_hk-10";